import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { getProductTypes } from '../../../redux/modules/productTypes/productType.selectors';
import { collegeDisclaimerMap } from '../../../settings/settings';
import Note from '../../Shared/Note/Note';
import { arrayToSentence } from '../../../utils/utils';
import If from '../../Shared/If/If';
import './ContributeDisclaimerNote.scss';
const ContributeDisclaimerNote = ({ productTypes, styleName, title = '' }) => {
  const { hasAK529, hasMD529, hasNAT529 } = productTypes;

  return (
    <Note
      className="e2e-contribute-disclaimer-note"
      styleName={styleName}
      title={title}
    >
      **Contributions cannot be made to a 529 account that will cause the
      aggregate balance of all accounts for that beneficiary to exceed the plan
      maximum. It is acceptable for earnings (but not contributions) to cause
      the total of the account values to exceed the plan maximum. For more
      information on the minimum and maximum amounts, please see the{' '}
      {arrayToSentence(
        [
          hasNAT529 && collegeDisclaimerMap.national,
          hasMD529 && collegeDisclaimerMap.maryland,
          hasAK529 && collegeDisclaimerMap.alaska,
        ]
          .filter((v) => v)
          .map(({ name, type, url }) => (
            <a
              className={`e2e-${type}-disclosure-link college-branded-link disclosure-document-link`}
              href={url}
              key={type}
              rel="noopener noreferrer"
              target="_blank"
            >
              {name}
            </a>
          ))
      )}{' '}
      .
      <br />
      <If test={hasAK529}>
        <p>
          ***To learn more about the{' '}
          <a
            className="rb-fund-editor-link college-branded-link college-branded-underline"
            href="https://www.alaska529plan.com/account-holder.html"
            rel="noreferrer"
            target="_blank"
          >
            Dash to Save More&trade;
          </a>
           incentive program and eligibility requirements, please read the terms
          and conditions at Alaska529plan.com/AccountHolder.
          <br />
          <span className="college-branded-bold">Dash to Save More&trade;</span>
           is a trademark of the Education Trust of Alaska.
        </p>
      </If>
    </Note>
  );
};

ContributeDisclaimerNote.propTypes = {
  productTypes: PropTypes.objectOf(PropTypes.bool),
  styleName: PropTypes.string,
  title: PropTypes.string,
};

const mapStateToProps = (state, { productTypes }) => ({
  productTypes: productTypes || getProductTypes(state),
});

export default compose(connect(mapStateToProps))(ContributeDisclaimerNote);
